import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { SketchPicker } from 'react-color';
import './ColorPicker.scss';
export const ColorPicker = (props) => {
    return props.open ? _jsx(OpenColorPicker, Object.assign({}, props)) : null;
};
const OpenColorPicker = ({ className, currentColor = '#000000', x = 0, y = 0, onChange, onClose }) => {
    const [container, setContainer] = useState(null);
    const [selectedColor, setSelectedColor] = useState(currentColor);
    const [position, setPosition] = useState({ x, y });
    const isInitialized = useRef(false);
    const pickerRef = useRef(null);
    useEffect(() => {
        const portalEle = document.createElement('div');
        portalEle.className = 'color-picker-portal';
        document.body.prepend(portalEle);
        setContainer(portalEle);
        const onGlobalClick = (e) => {
            if (isInitialized.current && e.target instanceof Node && !portalEle.contains(e.target)) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        };
        document.body.addEventListener('click', onGlobalClick);
        return () => {
            portalEle.remove();
            document.body.removeEventListener('click', onGlobalClick);
        };
    }, []);
    useEffect(() => {
        isInitialized.current = !!container;
    }, [container]);
    useEffect(() => {
        setSelectedColor(currentColor);
    }, [currentColor]);
    useLayoutEffect(() => {
        const picker = pickerRef.current;
        if (!picker)
            return;
        const margin = 8;
        const gap = 8;
        const { width, height } = picker.getBoundingClientRect();
        const rightPosition = x + gap;
        const preferredX = rightPosition + width <= window.innerWidth - margin
            ? rightPosition
            : x - width - gap;
        setPosition({
            x: Math.max(margin, Math.min(preferredX, window.innerWidth - width - margin)),
            y: Math.max(margin, Math.min(y, window.innerHeight - height - margin))
        });
    }, [container, x, y]);
    if (!container)
        return null;
    const clsx = [
        'color-picker',
        className !== null && className !== void 0 ? className : ''
    ].join('  ');
    return createPortal(_jsxs("div", { ref: pickerRef, className: clsx, style: { left: `${position.x}px`, top: `${position.y}px` }, children: [_jsx(SketchPicker, { color: selectedColor, className: "custom-sketch-picker", width: "200px", disableAlpha: false, presetColors: [
                    '#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321',
                    '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2',
                    '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'
                ], styles: {
                    default: {
                        picker: {
                            boxShadow: 'none'
                        }
                    }
                }, onChange: (color) => {
                    const nextColor = color.hex;
                    setSelectedColor(nextColor);
                    onChange === null || onChange === void 0 ? void 0 : onChange(nextColor);
                } }), _jsx("div", { className: "actions", children: _jsx("button", { onClick: onClose, children: "OK" }) })] }), container);
};
